import { useCallback, useEffect, useState } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";

/**
 * Fetches GET /admin/segments/segmentation-mode for the active brand.
 */
export function useSegmentationMode(brandName) {
    const [mode, setMode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        if (!brandName) {
            setMode(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await loyaltyFetch(`${LOYALTY_API_BASE}/admin/segments/segmentation-mode`, {
                headers: { "X-Brand": brandName },
            });
            const data = await res.json().catch(() => null);
            if (!res.ok) throw new Error(data?.detail || `Erreur HTTP ${res.status}`);
            setMode(data);
        } catch (err) {
            setError(err.message);
            setMode(null);
        } finally {
            setLoading(false);
        }
    }, [brandName]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    const usesUnomi = Boolean(
        mode?.currentBrandUsesUnomi || mode?.segmentationMode === "UNOMI"
    );

    return { mode, loading, error, refetch, usesUnomi };
}

export default useSegmentationMode;
